module.exports = __webpack_public_path__ + "img/page_head_06.0e343ee2.png";